import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../context/LanguageContext";

function PurpleBookPage() {
  const navigate = useNavigate();
  const { lang } = useLanguage();

  // --- Tabs ---
  const tabs = [
    { id: "main", label: "Main Story" },
    { id: "beyond", label: "Beyond the Mainline" },
    { id: "lore", label: "World & Lore" },
    { id: "codex", label: "Codex Condelia" },
    { id: "behind", label: "Behind Condelia " },
  ];

  // --- Pages for each tab ---
  const tabPages = {
    main: [
      {
        left: {
          title: "Main Storyline",
          text_th: "The Silence After The Spark......................................................\nFragments Unfound..................................................................\nThe Quiet Middleman................................................................\nThe Still Current..........................................................................\nThe Window And The Truth......................................................\nSo Close, Yet Still Far..................................................................\nFirst Move....................................................................................\n\n\nอ่านเพิ่มเติม :\n",
          text_en: "The Silence After The Spark......................................................\nFragments Unfound..................................................................\nThe Quiet Middleman................................................................\nThe Still Current..........................................................................\nThe Window And The Truth......................................................\nSo Close, Yet Still Far..................................................................\nFirst Move....................................................................................\n\n\Read more :\n"
        },
        right: {
          title: "Main Storyline",
          text_th: "......................................................................................Chapter 0\n......................................................................................Chapter 1\n......................................................................................Chapter 2\n......................................................................................Chapter 3\n......................................................................................Chapter 4\n......................................................................................Chapter 5\n......................................................................................Chapter 6\n",
          text_en: "......................................................................................Chapter 0\n......................................................................................Chapter 1\n......................................................................................Chapter 2\n......................................................................................Chapter 3\n......................................................................................Chapter 4\n......................................................................................Chapter 5\n......................................................................................Chapter 6\n",
        }
      }
    ],
    beyond: [
      {
        left: {
          title: "Beyond the Mainline",
          text_th: "The Morning After Rain (Ané Monie).......................................\nJust a Dream (Wynn Carwin)......................................................\nUnbound......................................................................................\nWorld collapse.............................................................................\n\n\nอ่านเพิ่มเติม :\n",
          text_en: "The Morning After Rain (Ané Monie).......................................\nJust a Dream (Wynn Carwin)......................................................\nUnbound......................................................................................\nWorld collapse.............................................................................\n\n\Read more :\n",
        },
        right: {
          title: "Beyond the Mainline",
          text_th: ".......................................................................Special Chapter 1\n.......................................................................Special Chapter 2\n.......................................................................Special Chapter 3\n.......................................................................Special Chapter 4\n",
          text_en: ".......................................................................Special Chapter 1\n.......................................................................Special Chapter 2\n.......................................................................Special Chapter 3\n.......................................................................Special Chapter 4\n"
        }
      }
    ],
    lore: [
      {
        left: {
          title: "World & Lore",
          text_th: "คอนเดเลีย คือมหานครขนาดใหญ่ภายใต้มหาสมุทร พวกเขาอาศัยอยู่ได้ด้วยร่างเหมือนมนุษย์ผ่านการพึ่งพาพลังของศิลาทั้งสามประเภท โดยเฉพาะอย่างยิ่ง แกนศิลา ที่ไม่สามารถขาดไปได้\n\nประเภทของศิลา\nแกนศิลา\n- ไม่มีใครรู้ว่ามันมีที่มาอย่างไร\n- สามารถมอบพลังงานให้กับทุกคนในเมืองได้\n- พลังงานนี้สามารถใช้แทนไฟฟ้าได้\n- พลังงานนี้สามารถเปลี่ยนสิ่งมีชีวิตแทบทุกชนิดให้กลายเป็นร่างมนุษย์ได้",
          text_en: "Condelia is a vast metropolis beneath the ocean. Its inhabitants live in human-like forms due to the power of three types of crystals, most importantly, the Main Crystal, which cannot be replaced.\n\nCrystal Types\nTHE MAIN CRYSTAL\n- No one knows where it originated.\n- Provides energy for everyone in the city.\n- This energy can function like electricity.\n- It can transform (almost) any living creature into a human form."
        },
        right: {
          title: "World & Lore",
          text_th: "ประเภทของศิลา\nศิลาธารลึก\n- สามารถพบในทะเลลึก\n- ให้พลังงานจำนวนมากเพื่อหล่อเลี้ยงแกนศิลา\n- มีความทนทานสูง แตกหักยาก\n- มีหน่วยงานเฉพาะที่รับผิดชอบในการเก็บรวบรวม\n- สี: น้ำเงินเข้ม ม่วงเข้ม ไปจนถึงดำ\n\nศิลาวังกะรัง\n- พบในบริเวณแนวปะการัง\n- ให้พลังงานเพียงเล็กน้อย\n- เปราะบาง แตกง่าย\n- ไม่มีหน่วยงานเฉพาะที่รับผิดชอบในการเก็บ\n- มักถูกใช้เป็นของตกแต่ง\n- สี: ส้ม เหลือง ชมพู",
          text_en: "Crystal Types\nTHE BENTHIC CRYSTAL\n- Found deep in the ocean.\n- Generates a large amount of energy that supports the Main Crystal.\n- Very durable; difficult to break.\n- Collected only by a designated agency.\n- Color: deep blue or dark purple to black.\n\nTHE CORAL CRYSTAL\n- Found within coral reef areas.\n- Provides only a small amount of energy.\n- Fragile and breaks easily.\n- No specific agency is in charge of collecting them.\n- Commonly used for decoration.\n- Color: orange, yellow, pink."
        }
      }
    ],
    codex: [
      {
        left: {
          title: "Codex Condelia",
          text_th: "to be updated",
          text_en: "to be updated",
        },
        right: {
          title: "Codex Condelia",
          text_th: "",
          text_en: "",
        }
      }
    ],
    behind: [
      {
        left: {
          title: "Behind Condelia",
          text_th: "ทำไมต้องเป็นแมงกะพรุน?\nแมงกะพรุนเป็นสัตว์ที่โดดเด่น พวกมันมีความหลากหลายทั้งสีและสายพันธุ์ เป็นสัตว์ที่สวยงาม เปราะบาง ถูกกระแสน้ำพัดพาได้ง่าย ถึงอย่างนั้นก็ยังมีวิธีปกป้องตัวเองอย่างสง่างาม เราเลือกให้\nแอนเน่ โมนี่ เป็นแมงกะพรุน เพราะบุคลิกของเธอสะท้อนสิ่งนั้นได้ดีเยี่ยม คือภาพลักษณ์ที่ดูน่ารัก อ่อนโยน แต่ภายในกลับซ่อนความเข้มแข็งที่ไม่มีใครคาดคิด\n\nทำไมต้องเป็นทากทะเล?\n​​ทากทะเลเป็นสัตว์ตัวเล็ก ๆ ที่มักถูกมองข้าม ถึงอย่างนั้นก็ยังมีความน่ารัก ไม่มีพิษภัยอะไรกับใคร เราเลยเลือกให้ วินน์ คาร์วิน เป็นทากทะเลเพียงเพื่อชวนคำถามง่าย ๆ ว่า ถ้าคนที่สังคมไม่เคยมองเห็น กลับเป็นคนที่สร้างประโยชน์มหาศาลให้สังคมได้ล่ะ…จะทำอย่างไร?",
          text_en: "Why the Jellyfish?\nJellyfish are unique creatures, diverse in color and breed, beautiful yet fragile, easily carried by the current, yet possessing elegant ways to protect themselves.We chose Ané Monie to be a jellyfish because her personality reflects these qualities: a gentle, adorable appearance that conceals a strength no one expects.\n\nWhy the Sea Slug?\nSea slugs are small creatures often overlooked, yet harmless and charming in their own way. We chose Wynn Carwin to be a sea slug to pose a simple question “What if the person society never noticed turns out to be the one who can bring immense good to it?”"
        },
        right: {
          title: "Behind Condelia",
          text_th: "ทำไมต้องเป็นปลาพยาบาล?\nปลาพยาบาล คือความมหัศจรรย์ของห่วงโซ่อาหาร พวกมันรอดมาได้เพราะ “การดูแล” ไม่ใช่ “การล่า” บทบาทของมันคือผู้ช่วยที่ทำให้ห่วงโซ่อาหารสมดุลและเดินหน้าต่อไปได้อย่างดีเยี่ยม เป็นสัตว์ที่มีความสำคัญไม่ต่างไปจากสิ่งมีชีวิตอื่น แต่กลับถูกมองเป็นแค่ตัวประกอบ นั่นคือเหตุผลที่เราเลือกให้ โจเซ็ตเต้ ราเซ็ต เป็นปลาพยาบาล คนที่โดดเด่นเรื่องการสนับสนุน การปรับตัว และการรู้คุณค่าที่ตนสร้างให้กับคนรอบข้าง แม้บทบาทจะเหมือนตัวประกอบ แต่เธอคือหนึ่งในแรงขับเคลื่อนหลักของเมืองนี้\n\nทำไมต้องเป็นโลมาสีชมพู?\nโลมาสีชมพูเป็นสัตว์ที่ทั้งเป็นมิตร น่ารัก หากแต่ยากที่จะตามหา เราเลยเลือกให้ เดน เทรนตัน ได้เป็นสัตว์ชนิดนี้ เพื่อสะท้อนถึง beauty privilege ที่มาพร้อมกับรูปลักษณ์ของเขา ที่อาจเปิดประตูแห่งโอกาสได้ง่ายดาย แต่นั่นก็เป็นดาบสองคม เพราะมันอาจทำให้เขาถูกตัดสินก่อนที่ใครจะได้รู้จักตัวตนจริง ๆ ได้เช่นกัน",
          text_en: "Why the Nursefish?\nThe nursefish is one of the most fascinating creatures in the ecosystem. It survives not through predation, but through care which quietly maintains balance within its environment. Often overlooked, its role is essential. Like a nursefish, Josette Wrasset supports others, adapts with ease, and understands her own value. Though she may seem secondary, she is one of the true forces keeping the city alive.\n\nWhy the Pink Dolphin?\nPink dolphins are friendly, charming, and rare. We chose Den Trenton to represent this species to reflect the beauty privilege that comes with his appearance, something that may open doors for him more easily, yet acts as a double-edged sword. Because it can also make people judge him long before they ever learn who he truly is."
        }
      }
    ]
  };

  // --- Active tab & page state ---
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [pageIndex, setPageIndex] = useState(0); // always start at page 0

  // --- Handle bookmark click ---
  const handleBookmarkClick = (tab) => {
    setActiveTab(tab.id);
    setPageIndex(0);
  };

  const currentPage = tabPages[activeTab][pageIndex];

  return (
    <div className="w-full overflow-x-auto bg-gradient-to-b from-[#131b33] to-black">
      <div className="flex justify-center items-center w-full min-h-screen">
        <div
          className="
            relative
            aspect-[16/10]
            w-full
            max-w-[1080px]
            min-w-[250px]
          "
        >
          {/* BACKGROUND IMAGES */}
          <img src="/books/coverbook_purple.webp" className="absolute inset-0 object-cover z-0" />
          <img src="/books/postcard.webp" className="absolute inset-0 object-cover w-6/12 z-10 -top-2" />

          <img
            src="/books/home_icon.webp"
            alt="home icon"
            className="absolute z-20 mt-[10%] left-[2%] w-[3%] cursor-pointer"
            onClick={() => navigate("/")}
          />

          <img src="/books/bottom.webp" className="absolute inset-0 object-cover z-10 pointer-events-none" />
          <img src="/books/middle.webp" className="absolute inset-0 object-cover z-20 pointer-events-none" />
          <img src="/books/above.webp" className="absolute inset-0 object-cover z-30 pointer-events-none" />

          {/* --- BOOKMARKS --- */}
          <div className="absolute right-[-2%] mt-[8%] z-20 flex flex-col gap-3 pointer-events-auto w-[10%]">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <motion.div
                  key={tab.id}
                  className="relative cursor-pointer"
                  onClick={() => handleBookmarkClick(tab)}
                  whileHover={{ scale: 1.05 }}
                >
                  <img
                    src={isActive ? "/books/bookmark_active.webp" : "/books/bookmark_inactive.webp"}
                    alt={tab.label}
                    className={isActive ? "w-[100%]" : "w-[120%]"}
                  />
                  <span
                    className={`absolute inset-0 ml-[12%] mt-[5%] px-[1%] py-[10%] flex text-black font-bold font-eng
                    ${isActive ? "text-[clamp(0.1rem,1vw,0.9rem)]" : "text-[clamp(0.1rem,1vw,0.8rem)]"}`}
                  >
                    {tab.label}
                  </span>
                </motion.div>
              );
            })}
          </div>

          {/* --- CONTENT AREA --- */}
          <div className="absolute top-[8%] left-0 right-0 z-30 px-[10%] flex gap-8 h-[65%] pointer-events-none">
            {/* LEFT PAGE */}
            <div className="w-1/2 p-[0.2%] overflow-y-auto">
              <h2 className="font-bold mb-3 font-eng
               text-[clamp(0.1rem,2vw,1.6rem)]">
                {currentPage.left.title}
              </h2>
              <p className={`text-gray-800 whitespace-pre-line leading-relaxed
              text-[clamp(0.3rem,1vw,0.9rem)]
              ${lang == "TH" ? "font-thai" : "font-eng"}
              ${currentPage.left.title === "Codex Condelia" ? "text-red-600" : "text-gray-800"}`}
              >
                {lang == "TH" ? currentPage.left.text_th : currentPage.left.text_en}
              </p>
              <a
                href="https://www.readawrite.com/a/ca1850ba355129f1992efe61bc4c3b7b"
                target="_blank"
                rel="noopener noreferrer"
                className={`
                  text-blue-600 underline font-eng pointer-events-auto 
                  ${currentPage.left.title === "Main Storyline" || currentPage.left.title === "Beyond the Mainline" ? "opacity-100" : "opacity-0"}
                  text-[clamp(0.5rem,1.5vw,0.8rem)]
                `}
              >https://www.readawrite.com/a/ca1850ba355129f1992efe61bc4c3b7b</a>
            </div>

            {/* RIGHT PAGE */}
            <div className="w-1/2 p-[0.2%] overflow-y-auto">
              <h2
                className={`
                  font-bold mb-3 font-eng
                  text-[clamp(0.8rem,2vw,1.6rem)] 
                  ${currentPage.right.title === currentPage.left.title ? "opacity-0" : "opacity-100"
                }`}
              >
                {currentPage.right.title}
              </h2>
              <p className={`text-gray-800 whitespace-pre-line leading-relaxed
              text-[clamp(0.3rem,1vw,0.9rem)]
              ${lang == "TH" ? "font-thai" : "font-eng"}`}>
                {lang == "TH" ? currentPage.right.text_th : currentPage.right.text_en}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PurpleBookPage;
